// DO NOT EDIT! This file is generated automaticaly with 'npm run generate-stimulus'

import * as Turbo from "@hotwired/turbo";
import { Application } from "stimulus";
const application = Application.start();

import { default as AutoscrollingImages } from "./../back/jdd-components/autoscrolling-images/autoscrolling-images.stimulus.js";
application.register("autoscrolling-images", AutoscrollingImages);

import { default as Countdown } from "./../back/jdd-components/countdown/countdown.stimulus.js";
application.register("countdown", Countdown);

import { default as MapWithPins } from "./../back/jdd-components/map-with-pins/map-with-pins.stimulus.js";
application.register("map-with-pins", MapWithPins);

import { default as HorizontalScroller } from "./../back/routes/common/horizontal-scroller/horizontal-scroller.stimulus.js";
application.register("horizontal-scroller", HorizontalScroller);

import { default as Copy } from "./controllers/copy.stimulus.js";
application.register("copy", Copy);

import { default as Modal } from "./controllers/modal.stimulus.js";
application.register("modal", Modal);

import { default as AutogrowTextarea } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/autogrow-textarea.stimulus.js";
application.register("autogrow-textarea", AutogrowTextarea);

import { default as AutosubmitOnKeypress } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/autosubmit-on-keypress.stimulus.js";
application.register("autosubmit-on-keypress", AutosubmitOnKeypress);

import { default as Autosubmit } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/autosubmit.stimulus.js";
application.register("autosubmit", Autosubmit);

import { default as CodeSnippet } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/code-snippet.stimulus.js";
application.register("code-snippet", CodeSnippet);

import { default as ComponentDebugger } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/component-debugger.stimulus.js";
application.register("component-debugger", ComponentDebugger);

import { default as ExportableTextarea } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/exportable-textarea.stimulus.js";
application.register("exportable-textarea", ExportableTextarea);

import { default as InputImagePreview } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/input-image-preview.stimulus.js";
application.register("input-image-preview", InputImagePreview);

import { default as JddTablePaste } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/jdd-table-paste.stimulus.js";
application.register("jdd-table-paste", JddTablePaste);

import { default as JsonDialog } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/json-dialog.stimulus.js";
application.register("json-dialog", JsonDialog);

import { default as JsonEditor } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/json-editor.stimulus.js";
application.register("json-editor", JsonEditor);

import { default as MarkdownInput } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/markdown-input.stimulus.js";
application.register("markdown-input", MarkdownInput);

import { default as RefreshOnTsChanges } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/refresh-on-ts-changes.stimulus.js";
application.register("refresh-on-ts-changes", RefreshOnTsChanges);

import { default as RefreshStyles } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/refresh-styles.stimulus.js";
application.register("refresh-styles", RefreshStyles);

import { default as SubmitOnInput } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/submit-on-input.stimulus.js";
application.register("submit-on-input", SubmitOnInput);

import { default as Toast } from "./../../node_modules/@sealcode/jdd-editor/src/controllers/toast.stimulus.js";
application.register("toast", Toast);

import { default as Monaco } from "./../../node_modules/@sealcode/monaco-wrapper/src/controllers/monaco.stimulus.js";
application.register("monaco", Monaco);

import { default as PasswordGenerateButton } from "./../../node_modules/@sealcode/sealgen/src/controllers/password-generate-button.stimulus.js";
application.register("password-generate-button", PasswordGenerateButton);

import { default as SealgenTable } from "./../../node_modules/@sealcode/sealgen/src/controllers/sealgen-table.stimulus.js";
application.register("sealgen-table", SealgenTable);

import { default as Sortable } from "./../../node_modules/@sealcode/sortable/src/controllers/sortable.stimulus.js";
application.register("sortable", Sortable);

export { Turbo };
